const mapMarkers = {
    Brand: {
        default: [
            {
                gender: 'Female',
                age: 18,
                location: 'Argentina',
                interests: 'City life, Fashion, Lifestyle',
                image: require('images/faces/argentina.jpg'),
                likes: 4405,
                engRate: 7.5,
                pos_x: 400,
                pos_y: 750
            },
            {
                gender: 'Female',
                age: 25,
                location: 'Barcelona',
                interests: 'Lifestyle, Fashion, Beauty, Night Life',
                image: require('images/faces/barcelona.jpg'),
                likes: 889,
                engRate: 8.4,
                pos_x: 620,
                pos_y: 421
            },
            {
                gender: 'male',
                age: 25,
                location: 'brazil',
                interests: 'sports, cars, outdoors',
                image: require('images/faces/brazil.jpg'),
                likes: 188,
                engrate: 2.8,
                pos_x: 450,
                pos_y: 650
            },
            {
                gender: 'female',
                age: 35,
                location: 'british columbia',
                interests: 'outdoors, beauty, sports',
                image: require('images/faces/british_columbia.jpg'),
                pos_x: 200,
                pos_y: 360,
                engrate: 5.1
            },
            {
                gender: 'female',
                age: 22,
                location: 'chicago',
                interests: 'art, photography, sports',
                image: require('images/faces/chicago.jpg'),
                pos_x: 300,
                pos_y: 400,
                engrate: 6.7
            },
            {
                gender: 'male',
                age: 34,
                location: 'florida',
                interests: 'music, food, sports',
                image: require('images/faces/florida.jpg'),
                likes: 1816,
                engrate: 3.4,
                pos_x: 302,
                pos_y: 480
            },
            {
                gender: 'female',
                age: 21,
                location: 'hong kong',
                interests: 'city life, beauty',
                image: require('images/faces/hong_kong.jpg'),
                likes: 3412,
                engrate: 2.1,
                pos_x: 1100,
                pos_y: 500
            },
            {
                gender: 'female',
                age: 40,
                location: 'india',
                interests: 'sports, lifestyle, food',
                image: require('images/faces/india.jpg'),
                likes: 4544,
                engrate: 4.4,
                pos_x: 960,
                pos_y: 510
            },
            {
                gender: 'male',
                age: 31,
                location: 'london',
                interests: 'sports, art',
                image: require('images/faces/london.jpg'),
                likes: 1392,
                engrate: 4.4,
                pos_x: 634,
                pos_y: 360
            },
            {
                gender: 'male',
                age: 18,
                location: 'los angeles',
                interests: 'music, photography, dogs, lifestyle',
                image: require('images/faces/los_angeles.jpg'),
                likes: 327,
                engrate: 4.4,
                pos_x: 160,
                pos_y: 440
            },
            {
                gender: 'female',
                age: 24,
                location: 'morocco',
                interests: 'fashion, photography, art, pets',
                image: require('images/faces/morocco.jpg'),
                likes: 512,
                engrate: 3.1,
                pos_x: 600,
                pos_y: 460
            },
            {
                gender: 'male',
                age: 31,
                location: 'moscow',
                interests: 'hunting, cars, sports',
                image: require('images/faces/moscow.jpg'),
                likes: 1042,
                engrate: 5.5,
                pos_x: 800,
                pos_y: 340
            },
            {
                gender: 'male',
                age: 24,
                location: 'new york',
                interests: 'fashion, photography, art, pets',
                image: require('images/faces/new_york.jpg'),
                likes: 5451,
                engrate: 3.1,
                pos_x: 356,
                pos_y: 402
            },
            {
                gender: 'male',
                age: 33,
                location: 'sweden',
                interests: 'hiking, fashion, hunting',
                image: require('images/faces/sweden.jpg'),
                likes: 4544,
                engrate: 3.2,
                pos_x: 690,
                pos_y: 320
            },
            {
                gender: 'male',
                age: 33,
                location: 'sydney',
                interests: 'hiking, sports, photography',
                image: require('images/faces/sydney.jpg'),
                likes: 721,
                engrate: 9.2,
                pos_x: 1230,
                pos_y: 766
            },
            {
                gender: 'female',
                age: 38,
                location: 'tokyo',
                interests: 'hiking, fashion, photography',
                image: require('images/faces/tokyo.jpg'),
                likes: 784,
                engrate: 7.2,
                pos_x: 1180,
                pos_y: 440
            },
            {
                gender: 'female',
                age: 31,
                location: 'yemen',
                interests: 'fashion, food, city life',
                image: require('images/faces/yemen.jpg'),
                likes: 8511,
                engrate: 3.8,
                pos_x: 828,
                pos_y: 536
            }
        ],
    },
    Target: {
        default: [
            {
                gender: 'male',
                age: 18,
                location: 'argentina',
                interests: 'music, photography, dogs, lifestyle',
                image: require('images/brand_ambassadors/user_demographic_map/argentina.png'),
                likes: 327,
                engrate: 4.4,
                pos_x: 460,
                pos_y: 715,
                tooltip_pos: 'q2'
            },
            {
                gender: 'female',
                age: 24,
                location: 'canada',
                interests: 'fashion, photography, art, pets',
                image: require('images/brand_ambassadors/user_demographic_map/canada.png'),
                likes: 512,
                engRate: 3.1,
                pos_x: 335,
                pos_y: 390,
                tooltip_pos: 'q1'
            },
            {
                gender: 'Male',
                age: 31,
                location: 'Ecuador',
                interests: 'Hunting, Cars, Sports',
                image: require('images/brand_ambassadors/user_demographic_map/ecuador.png'),
                likes: 1042,
                engRate: 5.5,
                pos_x: 305,
                pos_y: 600,
                tooltip_pos: 'q2'
            },
            {
                gender: 'Male',
                age: 24,
                location: 'India',
                interests: 'Fashion, Photography, Art, Pets',
                image: require('images/brand_ambassadors/user_demographic_map/india.png'),
                likes: 5451,
                engRate: 3.1,
                pos_x: 940,
                pos_y: 510,
                tooltip_pos: 'q1'
            },
            {
                gender: 'Male',
                age: 33,
                location: 'Malaysia',
                interests: 'Hiking, Fashion, Hunting',
                image: require('images/brand_ambassadors/user_demographic_map/malaysia.png'),
                likes: 4544,
                engRate: 3.2,
                pos_x: 1060,
                pos_y: 570,
                tooltip_pos: 'q4'
            },
            {
                gender: 'Male',
                age: 33,
                location: 'Mexico',
                interests: 'Hiking, Sports, Photography',
                image: require('images/brand_ambassadors/user_demographic_map/mexico.png'),
                likes: 721,
                engRate: 9.2,
                pos_x: 200,
                pos_y: 490,
                tooltip_pos: 'q2'
            },
            {
                gender: 'Female',
                age: 38,
                location: 'United Kingdom',
                interests: 'Hiking, Fashion, Photography',
                image: require('images/brand_ambassadors/user_demographic_map/uk.png'),
                likes: 784,
                engRate: 7.2,
                pos_x: 635,
                pos_y: 350,
                tooltip_pos: 'q4'
            },
            {
                gender: 'Female',
                age: 28,
                location: 'South Korea',
                interests: 'Fashion, Photography, Art, Food',
                image: require('images/brand_ambassadors/user_demographic_map/south_korea.png'),
                likes: 7213,
                engRate: 4.2,
                pos_x: 1135,
                pos_y: 430,
                tooltip_pos: 'q1'
            },
            {
                gender: 'Male',
                age: 32,
                location: 'South Africa',
                interests: 'Sports, Photography, Lifestyle',
                image: require('images/branded_content/user_demographic_map/south_africa.png'),
                likes: 982,
                engRate: 6.3,
                pos_x: 710,
                pos_y: 766,
                tooltip_pos: 'q2'
            }
        ],
        small: [
             {
                gender: 'male',
                age: 18,
                location: 'argentina',
                interests: 'music, photography, dogs, lifestyle',
                image: require('images/brand_ambassadors/user_demographic_map/argentina.png'),
                likes: 327,
                engrate: 4.4,
                pos_x: 280,
                pos_y: 400,
                tooltip_pos: 'q3'
            },
            {
                gender: 'female',
                age: 24,
                location: 'canada',
                interests: 'fashion, photography, art, pets',
                image: require('images/brand_ambassadors/user_demographic_map/canada.png'),
                likes: 512,
                engRate: 3.1,
                pos_x: 200,
                pos_y: 210,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Male',
                age: 31,
                location: 'Ecuador',
                interests: 'Hunting, Cars, Sports',
                image: require('images/brand_ambassadors/user_demographic_map/ecuador.png'),
                likes: 1042,
                engRate: 5.5,
                pos_x: 190,
                pos_y: 330,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Male',
                age: 24,
                location: 'India',
                interests: 'Fashion, Photography, Art, Pets',
                image: require('images/brand_ambassadors/user_demographic_map/india.png'),
                likes: 5451,
                engRate: 3.1,
                pos_x: 580,
                pos_y: 280,
                tooltip_pos: 'q4'
            },
            {
                gender: 'Male',
                age: 33,
                location: 'Malaysia',
                interests: 'Hiking, Fashion, Hunting',
                image: require('images/brand_ambassadors/user_demographic_map/malaysia.png'),
                likes: 4544,
                engRate: 3.2,
                pos_x: 650,
                pos_y: 320,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Male',
                age: 33,
                location: 'Mexico',
                interests: 'Hiking, Sports, Photography',
                image: require('images/brand_ambassadors/user_demographic_map/mexico.png'),
                likes: 721,
                engRate: 9.2,
                pos_x: 120,
                pos_y: 260,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Female',
                age: 38,
                location: 'United Kingdom',
                interests: 'Hiking, Fashion, Photography',
                image: require('images/brand_ambassadors/user_demographic_map/uk.png'),
                likes: 784,
                engRate: 7.2,
                pos_x: 390,
                pos_y: 195,
                tooltip_pos: 'q4'
            },
            {
                gender: 'Female',
                age: 28,
                location: 'South Korea',
                interests: 'Fashion, Photography, Art, Food',
                image: require('images/brand_ambassadors/user_demographic_map/south_korea.png'),
                likes: 7213,
                engRate: 4.2,
                pos_x: 700,
                pos_y: 235,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Male',
                age: 32,
                location: 'South Africa',
                interests: 'Sports, Photography, Lifestyle',
                image: require('images/branded_content/user_demographic_map/south_africa.png'),
                likes: 982,
                engRate: 6.3,
                pos_x: 440,
                pos_y: 430,
                tooltip_pos: 'q3'
            }
        ],
        medium: [
            {
                gender: 'male',
                age: 18,
                location: 'argentina',
                interests: 'music, photography, dogs, lifestyle',
                image: require('images/brand_ambassadors/user_demographic_map/argentina.png'),
                likes: 327,
                engrate: 4.4,
                pos_x: 350,
                pos_y: 490,
                tooltip_pos: 'q2'
            },
            {
                gender: 'female',
                age: 24,
                location: 'canada',
                interests: 'fashion, photography, art, pets',
                image: require('images/brand_ambassadors/user_demographic_map/canada.png'),
                likes: 512,
                engRate: 3.1,
                pos_x: 250,
                pos_y: 260,
                tooltip_pos: 'q1'
            },
            {
                gender: 'Male',
                age: 31,
                location: 'Ecuador',
                interests: 'Hunting, Cars, Sports',
                image: require('images/brand_ambassadors/user_demographic_map/ecuador.png'),
                likes: 1042,
                engRate: 5.5,
                pos_x: 230,
                pos_y: 420,
                tooltip_pos: 'q4'
            },
            {
                gender: 'Male',
                age: 24,
                location: 'India',
                interests: 'Fashion, Photography, Art, Pets',
                image: require('images/brand_ambassadors/user_demographic_map/india.png'),
                likes: 5451,
                engRate: 3.1,
                pos_x: 725,
                pos_y: 350,
                tooltip_pos: 'q1'
            },
            {
                gender: 'Male',
                age: 33,
                location: 'Malaysia',
                interests: 'Hiking, Fashion, Hunting',
                image: require('images/brand_ambassadors/user_demographic_map/malaysia.png'),
                likes: 4544,
                engRate: 3.2,
                pos_x: 815,
                pos_y: 400,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Male',
                age: 33,
                location: 'Mexico',
                interests: 'Hiking, Sports, Photography',
                image: require('images/brand_ambassadors/user_demographic_map/mexico.png'),
                likes: 721,
                engRate: 9.2,
                pos_x: 145,
                pos_y: 325,
                tooltip_pos: 'q2'
            },
            {
                gender: 'Female',
                age: 38,
                location: 'United Kingdom',
                interests: 'Hiking, Fashion, Photography',
                image: require('images/brand_ambassadors/user_demographic_map/uk.png'),
                likes: 784,
                engRate: 7.2,
                pos_x: 480,
                pos_y: 250,
                tooltip_pos: 'q4'
            },
            {
                gender: 'Female',
                age: 28,
                location: 'South Korea',
                interests: 'Fashion, Photography, Art, Food',
                image: require('images/brand_ambassadors/user_demographic_map/south_korea.png'),
                likes: 7213,
                engRate: 4.2,
                pos_x: 870,
                pos_y: 300,
                tooltip_pos: 'q3'
            },
            {
                gender: 'Male',
                age: 32,
                location: 'South Africa',
                interests: 'Sports, Photography, Lifestyle',
                image: require('images/branded_content/user_demographic_map/south_africa.png'),
                likes: 982,
                engRate: 6.3,
                pos_x: 550,
                pos_y: 530,
                tooltip_pos: 'q3'
            }
        ]
    },
    ContentNoLimits: {
        default: [
            {
                location: 'Australia',
                image: require('images/branded_content/user_demographic_map/australia.jpg'),
                pos_x: 1230,
                pos_y: 770,
                image_pos: 'q3'
            },
            {
                location: 'South Korea',
                image: require('images/branded_content/user_demographic_map/south_korea.png'),
                pos_x: 1135,
                pos_y: 430,
                image_pos: 'q2'
            },
            {
                location: 'Colombia',
                image: require('images/branded_content/user_demographic_map/colombia.png'),
                pos_x: 330,
                pos_y: 560,
                image_pos: 'q4'
            },
            {
                location: 'Eastern Brazil',
                image: require('images/branded_content/user_demographic_map/east_brazil.png'),
                pos_x: 460,
                pos_y: 650,
                image_pos: 'q3'
            },
            {
                location: 'Italy',
                image: require('images/branded_content/user_demographic_map/italy.jpg'),
                pos_x: 695,
                pos_y: 420,
                image_pos: 'q3'
            },
            {
                location: 'Mexico',
                image: require('images/branded_content/user_demographic_map/guatemala.png'),
                pos_x: 195,
                pos_y: 485,
                image_pos: 'q4'
            },
            {
                location: 'India',
                image: require('images/branded_content/user_demographic_map/india.jpg'),
                pos_x: 940,
                pos_y: 520,
                image_pos: 'q1'
            },
            {
                location: 'California',
                image: require('images/branded_content/user_demographic_map/california.png'),
                pos_x: 155,
                pos_y: 430,
                image_pos: 'q1'
            },
            {
                location: 'Chile',
                image: require('images/branded_content/user_demographic_map/north_brazil.png'),
                pos_x: 350,
                pos_y: 750,
                image_pos: 'q4'
            },
            {
                location: 'South Africa',
                image: require('images/branded_content/user_demographic_map/south_africa.png'),
                pos_x: 710,
                pos_y: 766,
                image_pos: 'q1'
            },
            {
                location: 'United Kingdom',
                image: require('images/branded_content/user_demographic_map/uk.png'),
                pos_x: 635,
                pos_y: 365,
                image_pos: 'q1'
            },
            {
                location: 'Virginia',
                image: require('images/branded_content/user_demographic_map/virginia.png'),
                pos_x: 330,
                pos_y: 435,
                image_pos: 'q3'
            }
        ],
        small: [
            {
                location: 'Australia',
                image: require('images/branded_content/user_demographic_map/australia.jpg'),
                pos_x: 778,
                pos_y: 425,
                image_pos: 'q3'
            },
            {
                location: 'South Korea',
                image: require('images/branded_content/user_demographic_map/south_korea.png'),
                pos_x: 705,
                pos_y: 245,
                image_pos: 'q2'
            },
            {
                location: 'Colombia',
                image: require('images/branded_content/user_demographic_map/colombia.png'),
                pos_x: 205,
                pos_y: 310,
                image_pos: 'q4'
            },
            {
                location: 'Eastern Brazil',
                image: require('images/branded_content/user_demographic_map/east_brazil.png'),
                pos_x: 285,
                pos_y: 360,
                image_pos: 'q3'
            },
            {
                location: 'Italy',
                image: require('images/branded_content/user_demographic_map/italy.jpg'),
                pos_x: 430,
                pos_y: 230,
                image_pos: 'q4'
            },
            {
                location: 'Mexico',
                image: require('images/branded_content/user_demographic_map/guatemala.png'),
                pos_x: 115,
                pos_y: 265,
                image_pos: 'q4'
            },
            {
                location: 'India',
                image: require('images/branded_content/user_demographic_map/india.jpg'),
                pos_x: 585,
                pos_y: 290,
                image_pos: 'q3'
            },
            {
                location: 'California',
                image: require('images/branded_content/user_demographic_map/california.png'),
                pos_x: 95,
                pos_y: 245,
                image_pos: 'q1'
            },
            {
                location: 'Chile',
                image: require('images/branded_content/user_demographic_map/north_brazil.png'),
                pos_x: 215,
                pos_y: 420,
                image_pos: 'q4'
            },
            {
                location: 'South Africa',
                image: require('images/branded_content/user_demographic_map/south_africa.png'),
                pos_x: 440,
                pos_y: 430,
                image_pos: 'q3'
            },
            {
                location: 'United Kingdom',
                image: require('images/branded_content/user_demographic_map/uk.png'),
                pos_x: 390,
                pos_y: 200,
                image_pos: 'q1'
            },
            {
                location: 'Virginia',
                image: require('images/branded_content/user_demographic_map/virginia.png'),
                pos_x: 200,
                pos_y: 245,
                image_pos: 'q2'
            }
        ],
        medium: [
            {
                location: 'Australia',
                image: require('images/branded_content/user_demographic_map/australia.jpg'),
                pos_x: 950,
                pos_y: 530,
                image_pos: 'q3'
            },
            {
                location: 'South Korea',
                image: require('images/branded_content/user_demographic_map/south_korea.png'),
                pos_x: 870,
                pos_y: 300,
                image_pos: 'q2'
            },
            {
                location: 'Colombia',
                image: require('images/branded_content/user_demographic_map/colombia.png'),
                pos_x: 250,
                pos_y: 380,
                image_pos: 'q4'
            },
            {
                location: 'Eastern Brazil',
                image: require('images/branded_content/user_demographic_map/east_brazil.png'),
                pos_x: 355,
                pos_y: 445,
                image_pos: 'q2'
            },
            {
                location: 'Italy',
                image: require('images/branded_content/user_demographic_map/italy.jpg'),
                pos_x: 530,
                pos_y: 290,
                image_pos: 'q3'
            },
            {
                location: 'Mexico',
                image: require('images/branded_content/user_demographic_map/guatemala.png'),
                pos_x: 145,
                pos_y: 335,
                image_pos: 'q4'
            },
            {
                location: 'India',
                image: require('images/branded_content/user_demographic_map/india.jpg'),
                pos_x: 725,
                pos_y: 355,
                image_pos: 'q3'
            },
            {
                location: 'California',
                image: require('images/branded_content/user_demographic_map/california.png'),
                pos_x: 120,
                pos_y: 300,
                image_pos: 'q1'
            },
            {
                location: 'Chile',
                image: require('images/branded_content/user_demographic_map/north_brazil.png'),
                pos_x: 265,
                pos_y: 520,
                image_pos: 'q4'
            },
            {
                location: 'South Africa',
                image: require('images/branded_content/user_demographic_map/south_africa.png'),
                pos_x: 550,
                pos_y: 530,
                image_pos: 'q3'
            },
            {
                location: 'United Kingdom',
                image: require('images/branded_content/user_demographic_map/uk.png'),
                pos_x: 485,
                pos_y: 250,
                image_pos: 'q1'
            },
            {
                location: 'Virginia',
                image: require('images/branded_content/user_demographic_map/virginia.png'),
                pos_x: 250,
                pos_y: 300,
                image_pos: 'q2'
            },
        ]
    }
};

export default mapMarkers;



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/map_markers.js